export const curVersion = '1.0.14'
export const versionComment = [
  {
    version: '1.0.14（2022-02-10）',
    versionStr: `- [完善] 若为提出人本人，则可以修改问题状态`,
  },
  {
    version: '1.0.13（2022-02-07）',
    versionStr: `- [完善] 工作量评估时间限制改为提出日期一个月内可改`,
  },
  {
    version: '1.0.12（2022-01-29）',
    versionStr: `- [完善] 优化一键排版的算法(仅按有序排列，例如: 1. 2. 3. 4. ...)
    - [完善] 问题汇总查看全部时，直接滑动到排序为 1 的位置
    - [完善] 问题汇总界面点击刷新刷剧后，保留筛选条件
    - [完善] 问题汇总界面暂时隐藏复选框列
    - [完善] 系统设置
    - [完善] 加前端、后端评价人`,
  },
  {
    version: '1.0.11（2022-01-25）',
    versionStr: `- [BUG] 修复高级过滤框点击全选再选其他项后，其他项会消失的问题
    - [BUG] 修复新增说明时，多岗情况下会有重复的说明类型
    - [新增] 进度可以修改人员
    - [完善] 新增一键排版说明功能
    - [BUG] 修复进度页面修改人员按钮权限控制问题`,
  },
  {
    version: '1.0.10（2022-01-24）',
    versionStr: `- [BUG] 截止日期需要能修改未来的日期`,
  },
  {
    version: '1.0.9（2022-01-18）',
    versionStr: `- [完善] 进度看板页面，移除待测试 tab`,
  },
  {
    version: '1.0.8（2022-01-17）',
    versionStr: `- [完善] "系统版本"列移动到"问题编号"和"模块"之间
    - [完善] 导出的"说明"列格式化，去除乱码
    - [修改] 汇总表附件优化
    - [新增] 新增进度表统计界面
    - [新增] 员工奖惩基础设置`,
  },
  {
    version: '1.0.7（2022-01-13）',
    versionStr: `- [完善] "说明类型"测试人员加"不处理"选项；提出人加"驳回"选项；所有人加"说明"选项
    - [完善] "说明类型"改为限制必填
    - [完善] 加版本更新说明
    - [修改] 附件功能优化
    - [BUG] 增加协助的后端研发岗位绑定错误的问题
    - [修改] 复杂筛选增加数据格式化功能(本次修改日期、大小写查询)
    - [修改] element-ui 为按需引入，减少项目体积
    - [修改] 合并公共组件，减少项目体积
    - [BUG] 提出人确认后，不会刷新当前数据`,
  },
  {
    version: '1.0.6（2022-01-12）',
    versionStr: `- [修改] 汇总附件模式修改 - [BUG]
          列头筛选搜索框输入和勾选框的联动 BUG 修复 - [完善]
          优化列头筛选同时多列进行筛选时的数据联动 - [完善]
          汇总界面修改人员时，限制必填`,
  },
  {
    version: '1.0.5(2022-01-11)',
    versionStr: `- [BUG] 修复列头筛选切换时，筛选条件刷新不及时的问题
    - [BUG] 修复撤销签名时报错的问题
    - [完善] 列头筛选增加高级筛选条件（包含、不包含）
    - [BUG] 修复列头筛选框无法过滤数字的问题`,
  },
  {
    version: '1.0.4(2022-01-10)',
    versionStr: `- [BUG] 修复列头筛选空值筛选不出来的问题
    - [BUG] 修复进度查看界面特殊权限获取失败的问题
    - [完善] 列头筛选加"仅筛选"功能；列头筛选操作体验优化`,
  },
  {
    version: '1.0.3(2022-01-10)',
    versionStr: `- [完善] 进度表加类型字段（新增、完善）
    - [完善] 汇总界面增加修改问题模块、问题内容、系统版本功能
    - [完善] 汇总界面"当前节点"列加筛选功能
    - [完善] 汇总界面修改后只进行局部刷新，需点击"刷新"按钮才可全量刷新
    - [完善] 登录界面增加记住用户名和密码功能`,
  },
  {
    version: '1.0.2(2022-01-07)',
    versionStr: `- [完善] 问题汇总界面固定列只固定到系统版本
    - [修复] 截止日期应可选未来的时间
    - [修复] 问题汇总界面说明编辑的权限问题修复
    - [完善] 问题汇总界面默认显示全部
    - [完善] 待办事项树节点调整、如没有我发起的自动跳转全部`,
  },
  {
    version: '1.0.1(2022-01-07)',
    versionStr: `- [完善] 修改密码后弹窗需关闭
    - [完善] 增加协助人弹窗增加前后端过滤
    - [完善] 超级权限可以评估任何人的工作量
    - [修复] 问题汇总导入时未关联数据的问题
    - [新增] 待办事项菜单
    - [修复] vxepro 在公网无法正常使用`,
  },
]
